/*
 * @Author: cc
 * @Date: 2019-12-21 21:31:55
 * @LastEditTime : 2019-12-23 23:11:16
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\newMedia\directive
 * @Description:新媒体渠道列表指令
 */
angular.module('newMediaListModule', []).directive('newMediaList', [
    'trsHttpService',
    'storageListenerService',
    'messagePublishService',
    'newMediaService',
    'trsspliceString',
    'editingCenterWeiBoService',
    function (trsHttpService, storageListenerService, messagePublishService, newMediaService, trsspliceString, editingCenterWeiBoService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/service/newMedia/template/list.html',
            replace: true,
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        enterKeycode: 13, // 回车键的键码
                        // btnRights: {}, // 按钮权限集合
                    };
                    $scope.data = {
                        selectedArray: [],
                        items: [],
                        keyWords: '',
                        // account: $state.params.account,
                    };
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 1,
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    requestData();
                    listenStorage();
                    refreshList();
                }

                /**
                 * [refreshList description]刷新列表
                 * @return  {[undefined]}  [return description]
                 */
                function refreshList() {
                    messagePublishService.subscribe(
                        'refresh',
                        function (event, data) {
                            requestData();
                        },
                        $scope
                    );
                }

                /**
                 * [listenStorage description]监听本地缓存
                 * @return {[promise]} [description] promise
                 */
                function listenStorage() {
                    storageListenerService.listenNewMedia(
                        function () {
                            requestData();
                            storageListenerService.removeListener($scope.parentStatus.storageName);
                        },
                        $scope,
                        $scope.parentStatus.storageName
                    );
                }

                /**
                 * [requestData description]获取数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function requestData() {
                    var params = {
                        PageSize: $scope.page.PAGESIZE,
                        CurrPage: $scope.page.CURRPAGE,
                        DocType: $scope.status.DocType,
                        OperTimeStart: $scope.data.fromdate,
                        OperTimeEnd: $scope.data.untildate,
                        searchKeyWord: $scope.data.keyWords,
                        timeType: 0,
                    };
                    params = angular.extend(params, $scope.params);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        $scope.data.items = data.DATA;
                        $scope.graphParams.ArticleIds = trsspliceString.spliceString($scope.data.items, $scope.parentStatus.idName, ',');
                        newMediaService.requestGraph($scope.data.items, $scope.graphParams, $scope.parentStatus.idName);
                        $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                        $scope.parentData.selectedArray = [];
                    });
                }

                /**
                 * [selectDoc description]单选
                 * @param   {[obj]}    item      [item description]选中的稿件
                 * @return  {[undefined]}        [return description]
                 */
                $scope.selectDoc = function (item) {
                    if ($scope.parentData.selectedArray.indexOf(item) < 0) {
                        $scope.parentData.selectedArray.push(item);
                    } else {
                        $scope.parentData.selectedArray.splice($scope.parentData.selectedArray.indexOf(item), 1);
                    }
                };

                /**
                 * [requestData description]全选
                 * @return {[type]} [description]
                 */
                $scope.selectAll = function () {
                    $scope.parentData.selectedArray =
                        $scope.parentData.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
                };

                /**
                 * [fullTextSearch description]搜索
                 * @param  {[obj]}    ev    [description]事件对象
                 * @return {[undefined]}    [description]
                 */
                $scope.fullTextSearch = function (ev) {
                    if ((ev && ev.keyCode === $scope.status.enterKeycode) || !ev) {
                        $scope.page.CURRPAGE = 1;
                        requestData();
                    }
                };

                /**
                 * [pageChanged description]翻页
                 * @return  {[type]}  [return description]
                 */
                $scope.pageChanged = function () {
                    requestData();
                };

                /**
                 * [jumpToPage description]跳页
                 * @return  {[type]}  [return description]
                 */
                $scope.jumpToPage = function () {
                    $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
                    $scope.loadingPromise = requestData();
                };

                /**
                 * [outSending description]按照时间搜索
                 * @param  {[type]} type [description] 搜索类型
                 * @param  {[type]} val [description] 过滤条件的值
                 * @return  {[type]}  [return description]
                 */
                $scope.queryByDropdown = function (type, val) {
                    if (type === 'DocType') {
                        $scope.status.DocType = val;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                };

                /**
                 * [qiehaoEditor description] 编辑百家号
                 * @param   {[type]}  docType    [docType description] 稿件类型
                 * @param   {[type]}  account    [account description] 账号id
                 * @param   {[type]}  articleid  [articleid description] 稿件id
                 * @return  {[type]}             [return description]
                 */
                $scope.typeEditor = function (docType, account, articleid) {
                    var routerName = `#/${
                        $scope.parentStatus.editPath[docType]
                        }?qiehaoaccount=${account}&qiehaoarticleid=${articleid}&qiehaoplatform=${0}`;
                    window.open(routerName);
                };

                /**
                 * [processRecord description] 获取企鹅号流程记录
                 * @param   {[type]}  item  [item description] 选中的企鹅号稿件
                 * @return  {[type]}        [return description]
                 */
                $scope.processRecord = function (item) {
                    item.SCMMICROCONTENTID = item.KUAIBAOARTICLEID;
                    item.MEDIATYPE = $scope.parentStatus.mediaType;
                    editingCenterWeiBoService.processRecord(item);
                };
            },
        };
    },
]);
